import { InspectionCompanyInformationDto } from 'dtos/companies'
import * as yup from 'yup'

export const InspectionCompanyInformationDtoValidator = yup.object<InspectionCompanyInformationDto>({
  inspectionCompanyCode: yup.string().max(25, 'Inspection Company Code cannot be more than 25 characters.').nullable()
})
